import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col px-5 pb-24" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = { class: "text-[12px]" }
const _hoisted_5 = {
  key: 0,
  class: "m-auto my-10 text-gray-100 font-bold"
}

import { ref, onMounted, computed, watch } from "vue"
  import { map } from "lodash"
  import { useCompanyStore } from "@/store/company"
  import { IonSearchbar, IonButton } from "@ionic/vue"
  import dateParser from "@/utils/dateParser"
  import router from "@/router"
  import { useRoute } from "vue-router"
  import { record } from "@/utils/analytics"

  // components
  import CardTemplate from "@/components/template/CardTemplate.vue"

  // image
  import CompanyLogo from "@/assets/images/discover/atlassian-image.svg"

  interface Props {
    companyColor?: string
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'JobPage',
  props: {
    companyColor: null
  },
  setup(__props: any) {

const props = __props as {
    companyColor?: string
  }

  

  const store = useCompanyStore()
  const route = useRoute()

  const resultJobs = ref<any>([])
  const allJobs = computed(() =>
    map(store.allJobs, (job) => ({
      id: job.job_id,
      department: job.department.join(" & ") || "",
      setup: job.condition && job.condition.work_setup ? job.condition.work_setup : "",
      title: job.title,
      employment: job.condition && job.condition.employment_type ? job.condition.employment_type : "",
      time: job.created || "",
      updated: job.updated || "",
      applicants: 0,
      image: job.display_link || store.companyDetails.logo,
      type: job.type,
      apply_link: job.apply_link,
      slug: job.slug,
    }))
  )

  /**
   * @event - any value
   * @query - get the value of event to lowercase
   * return result with the filter value of search query
   */
  const handleChange = async (event: any) => {
    const query = event.target.value.toLowerCase()
    resultJobs.value = allJobs.value.filter((job) => job.title.toLowerCase().indexOf(query) > -1) as any
  }

  const toSlug = (title: string) => {
    return title
      .trim()
      .replace(/&/g, "and")
      .replace(/\//g, " or ")
      .replace(/\s+/g, "-")
      .replace(/[^a-zA-Z0-9\- ]/g, "")
      .replace(/--/g, "-")
  }

  const goToJob = (job: any) => router.push(`/job-board/${store.companyDetails.slug}/${job.slug}/${toSlug(job.title.toLowerCase())}`)

  const getTimeDistance = (time: string, updated?: string) => {
    let datePosted = ""

    if (updated) datePosted = "Updated " + dateParser.computeDistanceToNow(updated)
    else if (time) datePosted = "Posted " + dateParser.computeDistanceToNow(time)
    else datePosted = "Date unspecified"

    return datePosted
  }

  onMounted(async () => {
    store.isNewState = true
    await store.retrieveAllJobs(
      {
        columns: "title,type,slug,condition,display_link,created,updated,department,job_id,apply_link",
      },
      router.currentRoute.value.params.slug as string
    )
    resultJobs.value = allJobs.value

    record({
      event: "CompanyViewPage",
      attributes: {
        link: route.fullPath,
        company_id: store.companyDetails.company_id,
      },
    })
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonSearchbar), {
      placeholder: "Search for jobs",
      debounce: 1000,
      class: "w-full p-0 custom mb-3",
      color: "light",
      onIonChange: _cache[0] || (_cache[0] = ($event: any) => (handleChange($event)))
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultJobs.value, (jobs) => {
      return (_openBlock(), _createBlock(CardTemplate, {
        key: `${jobs}_id`,
        class: "flex flex-col gap-3"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            class: "h-10 w-10 rounded-base",
            src: jobs.image,
            alt: ""
          }, null, 8, _hoisted_2),
          _createElementVNode("h2", _hoisted_3, _toDisplayString(jobs.title), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(jobs.department) + _toDisplayString(jobs.department && jobs.setup ? " · " : "") + _toDisplayString(jobs.setup) + " · " + _toDisplayString(getTimeDistance(jobs.time, jobs.updated)), 1),
          _createVNode(_unref(IonButton), {
            expand: "block",
            type: "button",
            color: "white",
            style: _normalizeStyle({ color: __props.companyColor || '#7442c8' }),
            class: "font-bold",
            onClick: ($event: any) => (goToJob(jobs))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Apply Now")
            ]),
            _: 2
          }, 1032, ["style", "onClick"])
        ]),
        _: 2
      }, 1024))
    }), 128)),
    (!resultJobs.value.length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, "No jobs found"))
      : _createCommentVNode("", true)
  ]))
}
}

})